import script from "./ConferenceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceForm.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceForm.vue?vue&type=style&index=0&id=b202581e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b202581e"]])

export default __exports__